import React from 'react';
import type {WidgetPart, CTAWidgetPayload, ActionEvent} from '../types';
import CTAWidget from './cta-widget';
import {ListWidget} from './list-widget';


interface WidgetRendererProps {
  part: WidgetPart;
  publishMessageAction?: (action: ActionEvent) => void;
  onResize?: () => void;
}

export function WidgetRenderer({
  part,
  publishMessageAction,
  onResize,
}: WidgetRendererProps) {
  const {data} = part;

  if (data.widget_type === 'list') {
    return (
      <ListWidget
        payload={data.payload}
        publishMessageAction={publishMessageAction}
        onResize={onResize}
      />
    );
  }

  if (data.widget_type === 'cta') {
    return (
      <CTAWidget
        data={data.payload as CTAWidgetPayload}
        publishMessageAction={publishMessageAction}
      />
    );
  }

  return null;
}
